export enum WidgetType {
  ALL_PATIENTS = 'all-patients',
  AKI_PATIENTS = 'aki-patients'
}
